module.exports = __webpack_public_path__ + "img/travel-agency.574f8d28.jpg";